<template>
  <div id="app" class="m-auto fullWidth">
    <transition name="fade">
      <RouterView />
    </transition>
    <div class="loading-warp" v-if="publicLoading.loading">
      <div class="loading-box">
        <img width="100" src="@/assets/loading.jpg" alt="" />
        <span>{{ publicLoading.text }}</span>
        <!-- <van-loading color="#0094ff" text-color="#0094ff" class="loading">
          {{ publicLoading.text }}
        </van-loading> -->
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue"
import { mapState } from "vuex"
import { defineComponent } from "@vue/composition-api"
import { Button, Toast } from "vant"
import { getBookCountByType } from "@/api/bookDetail"
import { getUserInfo } from "@/api/user"
import { getAppConfig, getIsOpenExchangeCode } from "@/api/index"
import { getPlatformImgApi, getWebSiteConfigApi, getAllPlatformListApi } from "@/api/home.js"
Vue.use(Toast)
Vue.use(Button)

// import SideBar from "@/components/SideBar.vue"
export default defineComponent({
  data() {
    return {
      scale: 1,
    }
  },
  computed: {
    ...mapState(["userInfo", "pathInfo", "publicLoading"]),
  },
  components: {
    // SideBar,
  },
  async created() {
    // this.$store.commit("SET_LOADING", { loading: true, text: "登录中..." })
    await this.getAppConfig()
    this.$watch(
      "$route",
      (to) => {
        console.log(to, 'watch $route')
        if (to.query.reopen) {
          window.location.href = to.query.reopen
          // 这里处理 reopen
        }

        // let query = Qs.parse(location.search.substring(1))
        // console.log(location.search, "------------------location.search")
        // if (!location.search) {
        //   let queryString = ""
        //   queryString = location.hash.replace("#/index?", "")
        //   query = Qs.parse(queryString) /* 登录回调地址 */
        // }
        // console.log(query, "------------------query")
        // let id_token = this.$route.query.token
        // console.log(id_token, "------------------id_token")
        // if (Array.isArray(id_token)) {
        //   id_token = id_token[0]
        // }
        // if (id_token) {
        //   this.$store.commit("SET_LOADING", { loading: true, text: "登录中..." })
        //   this.$store.dispatch("LOGIN", { token: id_token }).then(
        //     s => {
        //       this.$store.commit("SET_LOADING", { loading: false })
        //       console.log(this.pathInfo, "------------------this.pathInfo")
        //       const query = { ...this.$route.query }
        //       delete query.token
        //       this.$router.replace({
        //         query: query,
        //       })
        //       if (this.pathInfo.url) {
        //         window.location.href =
        //         this.pathInfo.url.replace(/([?&])token=[^&]*(&|$)/g, '$1').replace(/[?&]$/, '') || `${location.origin}${location.pathname}#/index`
        //       }
        //       setTimeout(() => {
        //         window.location.reload()
        //       }, 50)
        //     },
        //     e => {
        //       window.location.href = `${location.origin}${location.pathname}#/home`
        //     }
        //   )
        // }
      },
      { immediate: true }
    )

    const { code, data, msg } = await getBookCountByType({ ObjectType: 54 })
    if (code !== 200) {
      if(msg) {
        this.$toast(msg)
      }
    }
    this.$store.commit("CHANGE_BOOK_NUM", data !== 0)
  },
  mounted() {
    // 请求教材兑换权限开关
    this.getIsOpenExchangeCode()
  },
  methods: {
    async getIsOpenExchangeCode() {
      try {
        const { code, data } = await getIsOpenExchangeCode({})
        if (code === 200) {
          this.$store.commit("SET_IS_OPEN_EXCHANGE_CODE", data === '1')
        }else{
          this.$store.commit("SET_IS_OPEN_EXCHANGE_CODE", false)
        }
      } catch (error) {
        this.$store.commit("SET_IS_OPEN_EXCHANGE_CODE", false)
      }
    },
    async getAppConfig() {
      const { code, msg, data: configMap = {} } = await getAppConfig()
      if (code !== 200) {
        if(msg) {
          this.$toast(msg)
        }
        return
      }

      let errImg = (await getPlatformImgApi()).data
      window.__appBaseConfig__.ERR_IMG = errImg

      // https://book.ingpaper.com/downloadFile/2022/05/16/0506ed1e-5464-4f7c-aa22-e141279aa427.jpg

      let logo = (await getAllPlatformListApi()).data

      if (logo) {
        console.log(logo, "gogogogo")

        window.__appBaseConfig__.WEB_APP_LOGO_PATH = logo.find(item => item.type == "logo")?.value

        // window.__appBaseConfig__.WEB_APP_LOGO_PATH = 'https://saas-dcdx.keledge.com:50018/yjcbs/files/upload/743/743cda789beb80f3e0645ac2c72ca124.png'

        window.__appBaseConfig__.WEB_APP_SHARE_LOGO_PATH = logo.find(
          item => item.type == "poster"
        )?.value
        $("link[rel=icon]")[0].href = logo.find(item => item.type == "icon")?.value
        window.__appBaseConfig__.title = logo.find(item => item.type == "icon_text")?.value
        document.title = window.__appBaseConfig__.title || "数字教材出版平台"
      }

      let systemInfo = (await getWebSiteConfigApi()).data
      console.log(systemInfo, "---------systemInfosystemInfosystemInfo---------")

      if (systemInfo["business"]) {
        window.__appBaseConfig__.systemInfo.SERVICE_COPER = systemInfo["business"]
      }
      if (systemInfo["email"]) {
        window.__appBaseConfig__.systemInfo.SERVICE_EMAIL = systemInfo["email"]
      }
      if (systemInfo["tel"]) {
        window.__appBaseConfig__.systemInfo.SERVICE_TEL = systemInfo["tel"]
      }
      if (systemInfo["version"]) {
        window.__appBaseConfig__.systemInfo.SYSTEM_VERSION = systemInfo["version"]
      }
      console.log(window.__appBaseConfig__, "------------------")

      this.$store.commit("UPDATE_APP_CONFIG", window.__appBaseConfig__)
    },
  },
})
</script>

<style lang="less">
.fullWidth {
  max-width: 1920px;
}

#app {
  overflow: auto;
}

@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("@/assets/font/YouSheBiaoTiHei.ttf");
  font-weight: normal;
  font-style: normal;
}

@keyframes pulseRotate {
  0% {
    transform: rotate(0deg);
  }

  // 25% {
  //     transform: rotate(90deg);
  // }
  50% {
    transform: rotate(180deg);
  }

  // 75% {
  //     transform: rotate(270deg);
  // }
  100% {
    transform: rotate(360deg);
  }
}

.loading-warp {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999999;

  .loading-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      animation: pulseRotate 1s ease-in-out infinite;
    }

    span {
      padding-top: 20px;
      color: #4990e2;
    }
  }
}
</style>
